export const CHANNELS_SETTINGS_URL = 'real-time-channels'
export const CHANNELS_BASE_URL = '/services/plugin-channelmanager'
export enum CHANNELS_REST_ENDPOINTS {
    CHANNEL_TYPES = 'channeltypes',
    CHANNELS = 'channels'
}

export const ASSET_MANAGER_BASE_URL = 'services/plugin-aeapps-resources-manager'
export const MAPPED_CHANNELS_URL = 'assetinfos/MappedChannels/asset'
